import { MessageType } from "../../../entities/chat-support.entity";
import { ActiveChatMessage, ChatSummary, PendingMessage } from "../../../types/chat-support/chat-support.type";
import { dateToHH_MM } from "../../../utils/date.util";
import { ActiveChatImage } from "./active-chat-img";
import { useNavigate } from "react-router-dom";

type Props = {
  className?: string;
  user?: ChatSummary["user"];
  message: PendingMessage | ActiveChatMessage;
};

export const ActiveChatMsg = ({ className, user, message }: Props) => {
  const navigate = useNavigate();

  const handleUserClick = () => {
    if (user) {
      navigate(`/users/${user.userId}`);
    }
  };

  return (
    <div
      className={`flex min-w-[100px]  max-w-[150px] md:min-w-[180px] md:max-w-[250px]  ${user ? "ms-1" : "ms-auto"}`}
    >
      {user && (
        <img 
          className=" size-[40px] rounded-full  me-2 cursor-pointer hover:opacity-80 transition-opacity" 
          src={user.pictureURL} 
          alt="profile_Image" 
          onClick={handleUserClick}
          title="Click to view user details"
        />
      )}
      <div className="flex flex-col gap-2 w-full">
        <div className="flex items-center -justify-between">
          <span 
            className={`text-sm font-medium text-gray-800 ${user ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
            onClick={user ? handleUserClick : undefined}
            title={user ? "Click to view user details" : undefined}
          >
            {user ? user.name : "you"}
          </span>

          <span className=" text-xs text-gray-500 ms-auto">
            {dateToHH_MM(
              (message as ActiveChatMessage).createdAt ? (message as ActiveChatMessage).createdAt.toDate() : new Date()
            )}
          </span>
        </div>

        {message.type === MessageType.IMAGE ? (
          <ActiveChatImage src={message.content} />
        ) : (
          <p className={`${user ? "bg-white text-gray-700" : "bg-blue-500 text-white"}  p-2 rounded-md`}>
            {message.content}
          </p>
        )}
      </div>
    </div>
  );
};
